var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHyperPilotLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7246",
    "data-name": "Rectangle 7246",
    width: 38,
    height: 38,
    transform: "translate(0 0)",
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_19767",
    "data-name": "Group 19767",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11939",
    "data-name": "Path 11939",
    d: "M88.71,165.136a2.21,2.21,0,0,1-2.21-2.21V160a2.21,2.21,0,0,1,4.419,0v2.922a2.21,2.21,0,0,1-2.21,2.21",
    transform: "translate(-69.849 -127.355)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11940",
    "data-name": "Path 11940",
    d: "M163.14,90.92H160.27a2.21,2.21,0,1,1,0-4.419h2.871a2.21,2.21,0,0,1,0,4.419",
    transform: "translate(-127.659 -69.76)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11941",
    "data-name": "Path 11941",
    d: "M27.545,143.118a2.21,2.21,0,0,1-1.562-3.772l2.133-2.132a2.21,2.21,0,1,1,3.125,3.125l-2.133,2.133a2.2,2.2,0,0,1-1.562.647",
    transform: "translate(-20.436 -110.206)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11942",
    "data-name": "Path 11942",
    d: "M143.2,145.409a2.2,2.2,0,0,1-1.562-.647l-1.588-1.588a2.21,2.21,0,0,1,3.125-3.125l1.588,1.588a2.21,2.21,0,0,1-1.562,3.772",
    transform: "translate(-112.585 -112.497)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11943",
    "data-name": "Path 11943",
    d: "M32.8,48.312A15.506,15.506,0,1,1,48.311,32.806,15.523,15.523,0,0,1,32.8,48.312m0-26.593A11.087,11.087,0,1,0,43.892,32.806,11.1,11.1,0,0,0,32.8,21.719",
    transform: "translate(-13.945 -13.855)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11944",
    "data-name": "Path 11944",
    d: "M88.71,7.641a2.21,2.21,0,0,1-2.21-2.21V2.211a2.21,2.21,0,0,1,4.419,0v3.22a2.21,2.21,0,0,1-2.21,2.21",
    transform: "translate(-69.849 0.12)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11945",
    "data-name": "Path 11945",
    d: "M3.644,90.92H2.21a2.21,2.21,0,1,1,0-4.419H3.644a2.21,2.21,0,1,1,0,4.419",
    transform: "translate(0.031 -69.76)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11946",
    "data-name": "Path 11946",
    d: "M139.04,31.837a2.21,2.21,0,0,1-1.562-3.772l2.081-2.081a2.21,2.21,0,0,1,3.125,3.125L140.6,31.189a2.2,2.2,0,0,1-1.562.647",
    transform: "translate(-110.509 -20.347)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11947",
    "data-name": "Path 11947",
    d: "M29.137,31.347a2.2,2.2,0,0,1-1.563-.647l-1.593-1.593a2.21,2.21,0,0,1,3.125-3.125L30.7,27.575a2.21,2.21,0,0,1-1.562,3.772",
    transform: "translate(-20.436 -20.347)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11948",
    "data-name": "Path 11948",
    d: "M28.793,31a2.2,2.2,0,0,1-1.562-.647l-1.249-1.249a2.21,2.21,0,1,1,3.125-3.125l1.249,1.248A2.21,2.21,0,0,1,28.793,31",
    transform: "translate(-20.436 -20.347)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11949",
    "data-name": "Path 11949",
    d: "M79.62,90.368c3.161,3.927,1.461,8.289-3.5,9.109l-.207.032a.137.137,0,0,1-.151-.169c.18-.679.509-1.653.736-2.33.661-1.907,1.414-3.826,2.234-5.674.175-.368.339-.741.525-1.105a.136.136,0,0,1,.224-.025l.134.163",
    transform: "translate(-61.174 -72.713)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11950",
    "data-name": "Path 11950",
    d: "M67.121,77.743c-3.927,3.161-8.289,1.461-9.109-3.5l-.032-.207a.137.137,0,0,1,.169-.151c.679.18,1.653.509,2.33.736,1.907.661,3.826,1.414,5.674,2.234.368.175.741.339,1.105.525a.136.136,0,0,1,.025.224l-.163.134",
    transform: "translate(-46.808 -59.567)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11951",
    "data-name": "Path 11951",
    d: "M96.112,65.245c-3.161-3.927-1.461-8.289,3.5-9.109l.207-.032a.137.137,0,0,1,.151.169c-.18.679-.509,1.653-.736,2.33-.661,1.907-1.414,3.826-2.234,5.674-.175.368-.339.741-.525,1.105a.136.136,0,0,1-.224.025l-.134-.163",
    transform: "translate(-76.32 -45.202)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11952",
    "data-name": "Path 11952",
    d: "M92.245,94.236c3.927-3.161,8.289-1.461,9.109,3.5l.032.207a.137.137,0,0,1-.169.151c-.679-.18-1.653-.509-2.33-.736-1.907-.661-3.826-1.414-5.674-2.234-.368-.175-.741-.339-1.105-.525a.136.136,0,0,1-.025-.224l.163-.134",
    transform: "translate(-74.32 -74.715)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHyperPilotLogo);
export default __webpack_public_path__ + "static/media/hyper-pilot-logo.bf5746fb.svg";
export { ForwardRef as ReactComponent };